import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { UtilService } from 'hay-core-react';
import DashboardAjuda from './DashboardAjuda';

const COR_UPLOAD = { linha: 'rgb(34, 197, 94)', preenchimento: 'rgba(34, 197, 94, 0.15)' };
const COR_DOWNLOAD = { linha: 'rgb(59, 130, 246)', preenchimento: 'rgba(59, 130, 246, 0.15)' };

// Gráfico de área (Chart.js "line" com fill) do consumo médio de tráfego por hora do dia — dados
// já vêm prontos de UsuarioLog.dashboard().graficos.trafego (média por hora, calculada a partir só
// dos logs de desconexão, único tipo de log com bytesin/bytesout preenchidos).
class DashboardGraficoTrafego extends Component {
    render() {
        const { titulo, itens, help } = this.props;

        if (!itens || itens.every((item) => item.quantidade === 0)) {
            return (
                <div className="surface-card shadow-2 border-round p-3 h-full">
                    <div className="text-lg font-medium mb-3">{titulo}<DashboardAjuda texto={help} /></div>
                    <div className="text-color-secondary text-center p-4">
                        {UtilService.traduzir('main.dashboard.grafico.semdados')}
                    </div>
                </div>
            );
        }

        const labels = itens.map((item) => `${String(item.hora).padStart(2, '0')}h`);

        const data = {
            labels,
            datasets: [
                {
                    label: UtilService.traduzir('main.dashboard.grafico.trafego.upload'),
                    data: itens.map((item) => item.bytesin),
                    borderColor: COR_UPLOAD.linha,
                    backgroundColor: COR_UPLOAD.preenchimento,
                    fill: true,
                    tension: 0.3,
                    pointRadius: 0,
                },
                {
                    label: UtilService.traduzir('main.dashboard.grafico.trafego.download'),
                    data: itens.map((item) => item.bytesout),
                    borderColor: COR_DOWNLOAD.linha,
                    backgroundColor: COR_DOWNLOAD.preenchimento,
                    fill: true,
                    tension: 0.3,
                    pointRadius: 0,
                },
            ],
        };

        const options = {
            maintainAspectRatio: false,
            plugins: {
                legend: { position: 'top' },
                tooltip: {
                    callbacks: {
                        label: (contexto) => `${contexto.dataset.label}: ${UtilService.formatarBytesVolume(contexto.parsed.y)}`,
                    },
                },
            },
            scales: {
                x: {
                    ticks: {
                        autoSkip: false,
                        maxRotation: 0,
                        minRotation: 0,
                        font: { size: 9 },
                        callback: (valor, indice) => String(itens[indice].hora).padStart(2, '0'),
                    },
                },
                y: {
                    beginAtZero: true,
                    ticks: { callback: (valor) => UtilService.formatarBytesVolume(valor) },
                },
            },
        };

        return (
            <div className="surface-card shadow-2 border-round p-3 h-full" style={{ minWidth: 0 }}>
                <div className="text-lg font-medium mb-3">{titulo}<DashboardAjuda texto={help} /></div>
                <Chart type="line" data={data} options={options} style={{ width: '100%', height: '220px' }} />
            </div>
        );
    }
}

export default DashboardGraficoTrafego;
